export function initSearchBar() {
    document.querySelectorAll('.searchBar').forEach(form => {
        const button = form.querySelector('button[type="submit"]');
        const input = form.querySelector('input');
        if (!button || !input) return;

        button.addEventListener('mousedown', (e) => {
            e.preventDefault(); // prevent input losing focus when button is clicked
        });

        button.addEventListener('click', (e) => {
            if (!form.classList.contains('is-focus')) {
                e.preventDefault();
                input.focus();
            }
        });
    });
}
